import * as React from "react";
import facecloak_video from "./assets/FaceCloak.mp4";
import "./assets/styles.css";
import NavBar from "./navbar";

const footerStyle = {
  textAlign: "center",
  color: "#716969",
  fontSize: 10,
};

// const textStyle = {
//   textAlign : "center",
//   color: "#f0f0f0",
//   fontSize: 24
// }

const pageStyles = {
  color: "#232129",
  backgroundColor: "#ffffff",
  padding: 0,
  height: "100%",
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
  texColor: "#ffffff",
};

// center video in page
const vidStyle = {
  left: "50%",
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "20%",
  height: "auto",
};

const IndexPage = () => {
  return (
    <main style={pageStyles}>
      <title>Cogni-Trax</title>
      <NavBar />

      <video style={vidStyle} controls autoPlay loop>
        <source src={facecloak_video} type="video/mp4" />
      </video>

      <div id="footer" style={footerStyle}>
        <p className="copyright">&copy; Cogni-Trax </p>
      </div>
    </main>
  );
};

export default IndexPage;
